module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pe":"Primärenergie","peArea":"Primärenergie (Fläche)","peCount":"Primärenergie (Anzahl)","rh":"Raumwärme","rhArea":"Raumwärme (Fläche)","rhCount":"Raumwärme (Anzahl)"}}')
  delete Component.options._Ctor
}
